import { cn } from "@/lib/utils";
import { Link } from "react-router-dom";

interface EventData {
    title: string;
    description: string;
    url: string;
    image: string;
}

const events: EventData[] = [
    {
        title: "Saját utamon",
        description: "Saját utamon program",
        url: "/kapcsolat/sajat-utamon",
        image: "/images/sajat-utamon.webp",
    },
    {
        title: "Hogy vagy most?",
        description: "Hogy vagy most? program",
        url: "/kapcsolat/hogy-vagy-most",
        image: "/images/hogy-vagy-most.webp",
    },
];

export default function LatestEvents() {
    return (
        <>

<h2 className="text-3xl font-bold text-center mb-12 mt-12 text-purple-600 text-opacity-80 animate-wiggle animate-infinite"><Link to="/muveszetnapja" className="hover:text-purple-800">🎹 Művészet világnapja 🎹</Link></h2>
        <h2 className="text-3xl font-bold text-center mb-12 mt-12 text-purple-600 text-opacity-80 animate-wiggle animate-infinite"><Link to="/husvet2026" className="hover:text-purple-800">🐰 Játék! 🐰</Link></h2>
        
        <h2 className="text-2xl font-bold text-center mt-12 text-amber-800 text-opacity-80">Legújabb programok</h2>
        <section className="flex mx-auto mb-8 mt-8 w-3/4 text-center gap-4">
            {events.map((event, index) => (
                <EventItem
                    key={`event-${index}`}
                    className="flex-1"
                    title={event.title}
                    description={event.description}
                    url={event.url}
                    image={event.image}
                />
            ))}
        </section>
        </>
    )
}

const EventItem = ({
    title,
    description,
    url,
    image,
    className,
}: {
    title: string;
    description: string;
    url: string;
    image: string;
    className?: string;
}) => {
    return (
        <Link 
            to={url}
            className={cn(
                "flex text-black gap-4 flex-col",
                "transition-all duration-150 ease-in-out",
                "hover:scale-105 hover:shadow-lg",
                "rounded-lg overflow-hidden",
                "cursor-pointer",
                className
            )}
        >
            {/*<h3 className="text-lg font-bold">{title}</h3>
            <p className="text-sm text-gray-500">{description}</p>*/}
            <img src={image} alt={title} className="w-full h-full object-cover" />
        </Link>
    )
}